export enum DialogTypeEnum {
    Success = 1,
    Confirm = 2,
    Cancel = 3
}
